import './photo-slider.scss';
import 'slick-carousel';
import AOS from 'aos';
export default (() => {
  $('.js-photo-slider').slick({
    rows: 0,
    dots: false,
    infinite: true,
    swipeToSlide: true,
    centerMode: true,
    variableWidth: true,
    prevArrow: '.photo-slider__prev',
    nextArrow: '.photo-slider__next',
    responsive: [{
      breakpoint: 640,
      settings: {
        centerMode: false,
        variableWidth: false,
        slidesToShow: 1
      }
    }]
  });
  AOS.init({
    once: true
  });
});